export default __webpack_public_path__ + "imgs/social.90bbe0d86e1f00fd0666b954dd53983f.svg";